export default __webpack_public_path__ + "static/icons-47f3d3b731a9c10e3883b2ed44756de4.svg";